export const SCENARIO_DESCRIPTIONS = {
  current: {
    low: {
      description: "maintains current emission levels with minimal changes across all sectors.",
      panel_description: "2maintains current emission levels with minimal changes across all sectors.",
      color: 'gray'
    },
    high: {
      description: "maintains current emission levels with minimal changes across all sectors.",
      panel_description: "2maintains current emission levels with minimal changes across all sectors.",
      color: 'gray'
    }
  },
  steer: {
    low: {
      description: "You have chosen the panel scenario with less support measures, where change is slower and may stop sooner. You have assumed low levels of other action to reduce energy use.",
      panel_description: "Low levels of action to reduce energy demand in other areas.",
      color: 'blue'
    },
    high: {
      description: "You have chosen the panel scenario with more support measures, where change is faster and may continue for longer. You have assumed low levels of other action to reduce energy use.",
      panel_description: "Low levels of action to reduce energy demand in other areas.",
      color: 'blue'
    }
  },
  shift: {
    low: {
      description: "You have chosen the panel scenario with less support measures, where change is slower and may stop sooner. You have assumed moderate levels of other action to reduce energy use.",
      panel_description: "Moderate levels of action to reduce energy demand in other areas.",
      color: 'green'
    },
    high: {
      description: "You have chosen the panel scenario with more support measures, where change is faster and may continue for longer. You have assumed moderate levels of other action to reduce energy use.",
      panel_description: "Moderate levels of action to reduce energy demand in other areas.",
      color: 'green'
    }
  },
  transform: {
    low: {
      description: "You have chosen the panel scenario with less support measures, where change is slower and may stop sooner. You have assumed high levels of other action to reduce energy use.",
      panel_description: "High levels of action to reduce energy demand in other areas.",
      color: 'purple'
    },
    high: {
      description: "You have chosen the panel scenario with more support measures, where change is faster and may continue for longer. You have assumed high levels of other action to reduce energy use.",
      panel_description: "High levels of action to reduce energy demand in other areas.",
      color: 'purple'
    }
  },
  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    panel: {
      description: "You have chosen the panel's preferred scenario, with more support measures, where change is faster and may go on for longer. You have assumed moderate levels of other action to reduce energy use alongside higher levels of nature-based solutions for CDR.",
      panel_description: "More support measures, enabling faster change and sustaining the rate of change over time in all areas covered by the panel. Moderate levels of action to reduce energy demand in areas the panel didn't cover. More nature-based Carbon Dioxide Removal and less engineered removals",
      color: 'orange'
    }
  }
}
